Ext.define('SA.data.NaicsCodes', {
    extend: 'SA.data.BusinessCodes',
    singleton: true,

    resource: 'naicsCodes'
});